@if (customFieldDefinitions()) {
    <telxl-panel cardClass="mt-2">
        <ng-template #cardBody>
            <div class="row pb-4">
                <div class="offset-1 col-8 d-flex align-items-center">
                    <div
                        class="rounded-circle user-initials-sm me-2"
                        id="customer-details-initials"
                    >
                        <i class="fa-solid fa-user-plus"></i>
                    </div>
                    <div class="weight-medium truncate pe-2">
                        Create New End Customer Contact
                    </div>
                </div>
                <div class="col-1 d-flex align-items-center">
                    <telxl-button
                        class="w-100"
                        colour="light"
                        (buttonClick)="onCancel()"
                    >
                        Cancel
                    </telxl-button>
                </div>
                <div class="col-1 d-flex align-items-center">
                    <telxl-button
                        colour="primary"
                        class="w-100"
                        [outline]="true"
                        [disabled]="!canSave()"
                        (buttonClick)="create()"
                    >
                        Save
                    </telxl-button>
                </div>
            </div>

            <form
                class="customer-details-form customer-details-form--editing"
                [formGroup]="customerForm"
                (ngSubmit)="create()"
            >
                <div class="row">
                    <div class="col-3 label">
                        <label class="form-label" for="firstname">
                            First Name
                        </label>
                    </div>
                    <div class="col-8">
                        <input
                            formControlName="firstName"
                            type="text"
                            class="form-control"
                        />
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-3 label">
                        <label class="form-label" for="middlename">
                            Middle Name
                        </label>
                    </div>
                    <div class="col-8">
                        <input
                            formControlName="middleName"
                            type="text"
                            class="form-control"
                        />
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-3 label">
                        <label class="form-label" for="lastname">
                            Last Name
                        </label>
                    </div>
                    <div class="col-8">
                        <input
                            formControlName="lastName"
                            type="text"
                            class="form-control"
                        />
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-3 label">
                        <label class="form-label" for="email">
                            Email Address
                            <span class="text-danger">*</span>
                        </label>
                    </div>
                    <div class="col-8 position-relative">
                        <input
                            formControlName="email"
                            type="email"
                            class="form-control"
                            validateContactField
                            [formFieldInEditMode]="true"
                            [formFieldErrorMessage]="{
                                email: 'Please provide a valid email address.',
                                required:
                                    'Mandatory fields cannot be left blank.',
                                emailExists:
                                    'An end customer record exists with this email',
                            }"
                        />
                    </div>
                </div>

                <ng-container formArrayName="phoneNumbers">
                    @for (
                        phone of phoneNumbers.controls;
                        track phone;
                        let i = $index;
                        let last = $last
                    ) {
                        <div class="row mt-3" [formGroupName]="i">
                            <div class="col-3 label">
                                @if (i === 0) {
                                    <label
                                        class="form-label"
                                        for="phoneNumbers"
                                    >
                                        Phone Number
                                        <span class="text-danger">*</span>
                                    </label>
                                }
                            </div>
                            <div class="col-7 position-relative">
                                <input
                                    formControlName="number"
                                    type="text"
                                    class="form-control"
                                    validateContactField
                                    [formFieldInEditMode]="true"
                                    [formFieldErrorMessage]="{
                                        ukNumber:
                                            'Phone number must start with +44 or 0.',
                                        required:
                                            'Mandatory fields cannot be left blank.',
                                        phoneNumberExists:
                                            'An end customer record exists with this phone number',
                                        startsWithPlus44TooLong:
                                            'Numbers starting +44 have a maximum length of 13 ',
                                        startsWithZeroTooLong:
                                            'Numbers starting 0 have a maximum length of 11 ',
                                        invalid: 'This phone number is invalid',
                                    }"
                                />
                            </div>
                            <div
                                class="col-1 d-flex align-items-center justify-content-center"
                            >
                                <span class="phone-controls">
                                    @if (last) {
                                        <i
                                            class="fa-light fa-circle-plus"
                                            tabindex="0"
                                            (click)="addPhoneNumber()"
                                            (keypress)="addPhoneNumber()"
                                        ></i>
                                    } @else {
                                        <i
                                            class="fa-light fa-trash"
                                            tabindex="1"
                                            (click)="removePhoneNumber(i)"
                                            (keypress)="removePhoneNumber(i)"
                                        ></i>
                                    }
                                </span>
                            </div>
                        </div>
                    }
                </ng-container>

                <ng-container formArrayName="customFields">
                    @for (
                        customField of customFields.controls;
                        track customField;
                        let i = $index
                    ) {
                        <div class="row mt-3" [formGroupName]="i">
                            <div class="col-3 label">
                                <label class="form-label" for="customFields">
                                    {{
                                        getCustomFieldLabel(
                                            customField.get('fieldDefinitionId')
                                                ?.value
                                        )
                                    }}
                                </label>
                            </div>
                            <div class="col-8">
                                <div>
                                    @switch (
                                        getCustomFieldType(
                                            customField.get('fieldDefinitionId')
                                                ?.value
                                        )
                                    ) {
                                        @case ('Text') {
                                            <input
                                                formControlName="value"
                                                type="text"
                                                class="form-control"
                                            />
                                        }
                                        @case ('Choice') {
                                            <telxl-dropdown
                                                colour="dropdown"
                                                [outline]="true"
                                                [selected]="
                                                    getSelectedOption(
                                                        customField.get(
                                                            'fieldDefinitionId'
                                                        )?.value
                                                    )
                                                "
                                                [menuItems]="
                                                    getCustomFieldOptions(
                                                        customField.get(
                                                            'fieldDefinitionId'
                                                        )?.value
                                                    )
                                                "
                                                (selectedChange)="
                                                    onOptionSelected(
                                                        customField.get(
                                                            'fieldDefinitionId'
                                                        )?.value,
                                                        $event
                                                    )
                                                "
                                            />
                                        }
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </ng-container>
            </form>
        </ng-template>
    </telxl-panel>
}
